import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Badge, Box, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import FormlingContainer from '../../AgreementStudioModal/FormlingContainer/FormlingContainer';
import { normalizeVariableLabel } from '../TemplateVariables.utils';
import { useTemplateVariables } from '../TemplateVariablesContext';
import styles from './TemplateVariablesSection.module.scss';
export const GetTemplateVariablesSectionTID = (parentTestId)=>getTestIds(parentTestId);
export function TemplateVariablesSection(param) {
    let { wasSubmitted, isOpen, setIsOpen, testId } = param;
    const { TemplateVariablesSectionTestIds } = useMemo(()=>GetTemplateVariablesSectionTID(testId), [
        testId
    ]);
    const { t: sectionTexts } = useLocaleKeys('components.templateVariables.section');
    const { customVariables, templateVariableValues, setTemplateVariableValue, unresolvedCustomVariables, setShowVariableErrors, resolvedValues } = useTemplateVariables();
    useEffect(()=>{
        setShowVariableErrors(wasSubmitted);
    }, [
        wasSubmitted,
        setShowVariableErrors
    ]);
    const hasCustomVariables = customVariables.length > 0;
    const unresolvedNormalizedSet = useMemo(()=>new Set(unresolvedCustomVariables.map(normalizeVariableLabel)), [
        unresolvedCustomVariables
    ]);
    if (!hasCustomVariables) {
        return null;
    }
    const hasUnresolved = unresolvedNormalizedSet.size > 0;
    const badgeText = hasUnresolved ? sectionTexts.badgeNeedValues({
        count: unresolvedNormalizedSet.size
    }) : sectionTexts.badgeAllSet();
    const badgeSkin = hasUnresolved ? 'error' : 'success';
    const headerBadge = /*#__PURE__*/ _jsx(Badge, {
        skin: badgeSkin,
        rounded: true,
        outlined: true,
        testId: TemplateVariablesSectionTestIds.BadgeText(),
        children: badgeText
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": TemplateVariablesSectionTestIds.Root(),
        children: /*#__PURE__*/ _jsx(FormlingContainer, {
            title: sectionTexts.title(),
            togglePanelView: true,
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            testId: testId,
            headerExtra: headerBadge,
            children: /*#__PURE__*/ _jsx(Box, {
                className: styles.sectionContent,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.variablesGroup,
                    testId: TemplateVariablesSectionTestIds.CustomVariablesGroup(),
                    children: customVariables.map((label)=>{
                        var _ref, _templateVariableValues_normalized;
                        const normalized = normalizeVariableLabel(label);
                        const value = (_ref = (_templateVariableValues_normalized = templateVariableValues[normalized]) !== null && _templateVariableValues_normalized !== void 0 ? _templateVariableValues_normalized : resolvedValues[normalized]) !== null && _ref !== void 0 ? _ref : '';
                        const showError = wasSubmitted && unresolvedNormalizedSet.has(normalized);
                        return /*#__PURE__*/ _jsx("div", {
                            className: styles.customVariableRow,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: styles.customVariableField,
                                children: /*#__PURE__*/ _jsx(TextField, {
                                    bi: {
                                        name: 'template_variable_value'
                                    },
                                    label: label,
                                    value: value,
                                    onChange: (e)=>setTemplateVariableValue(label, e.target.value),
                                    testId: TemplateVariablesSectionTestIds.CustomVariableField(label),
                                    error: showError,
                                    helperText: showError ? sectionTexts.fieldError() : undefined,
                                    collapseHelperText: false
                                })
                            })
                        }, normalized);
                    })
                })
            })
        })
    });
}
